<h2 mat-dialog-title>{{ is_edit_mode ? 'Editar periodo OKR' : 'Crear periodo OKR' }}</h2>
<div mat-dialog-content>
  <form [formGroup]="form" class="period-form">
    <mat-radio-group class="period-presets" [value]="selected_preset_id()" (change)="selectPreset($event.value)">
      @for (option of preset_options; track option.id) {
        <mat-radio-button [value]="option.id" [disabled]="option.disabled">
          <span class="period-preset-label">
            {{ option.label }}
            @if (option.is_active) {
              <span class="period-preset-active-badge">Activo</span>
            }
            @if (option.disabled) {
              <span class="period-preset-hint"> (ya creado)</span>
            }
          </span>
        </mat-radio-button>
      }
    </mat-radio-group>

    @if (show_custom_range()) {
      <mat-form-field appearance="fill" class="period-range-field">
        <mat-label>Periodo</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="start_date" placeholder="Inicio" />
          <input matEndDate formControlName="end_date" placeholder="Fin" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-hint>Entre {{ min_period_duration_days }} y {{ max_period_duration_days }} días</mat-hint>
      </mat-form-field>
      @if (form.hasError('period_fully_ended') && form.touched) {
        <p class="period-error">El periodo no puede haber terminado ya. Si empieza en el pasado, debe terminar hoy o después.</p>
      } @else if (form.hasError('period_inverted') && form.touched) {
        <p class="period-error">La fecha de fin debe ser posterior o igual a la de inicio.</p>
      } @else if (form.hasError('period_too_short') && form.touched) {
        <p class="period-error">El periodo debe durar al menos {{ min_period_duration_days }} días.</p>
      } @else if (form.hasError('period_too_long') && form.touched) {
        <p class="period-error">El periodo no puede durar más de {{ max_period_duration_days }} días.</p>
      }
    }
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" (click)="save()" [disabled]="form.invalid">Guardar</button>
</div>
